import { jsxs, jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import AntSlider from "antd/es/slider";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './Slider.css';/* empty css            */
const Slider = ({
  className,
  classNameWrapper,
  classNameHeader,
  classNameValue,
  classNameLabel,
  vertical,
  tooltip,
  label,
  value,
  valueVisible = true,
  valueFormatter,
  ...props
}) => {
  const {
    open: tooltipOpen = false,
    placement: tooltipPlacement = !vertical ? "bottom" : "right",
    ...tooltipProps
  } = tooltip || {};
  const resolvedTooltip = useMemo(() => {
    return {
      open: tooltipOpen,
      placement: tooltipPlacement,
      className: classnames("perxis-auto-slider-tooltip"),
      ...tooltipProps
    };
  }, [tooltipOpen, tooltipPlacement, tooltipProps]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classnames(
        [
          "perxis-auto-slider-wrapper",
          {
            "perxis-auto-slider-wrapper--vertical": vertical
          }
        ],
        classNameWrapper
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-slider-header", classNameHeader), children: [
          !!label && /* @__PURE__ */ jsx(
            Typography.Paragraph,
            {
              level: "main",
              color: "darkest",
              className: classnames("perxis-auto-slider-header__label", classNameLabel),
              children: label
            }
          ),
          !!valueVisible && /* @__PURE__ */ jsx(
            Typography.Title,
            {
              headingLevel: 5,
              color: "darkest",
              className: classnames("perxis-auto-slider-header__value", classNameValue),
              children: valueFormatter ? valueFormatter(value) : value
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          AntSlider,
          {
            range: false,
            value,
            className: classnames("perxis-auto-slider", className),
            vertical,
            tooltip: resolvedTooltip,
            ...props
          }
        )
      ]
    }
  );
};
export {
  Slider as default
};
//# sourceMappingURL=Slider.js.map
